import script from "./AppNav.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppNav.vue?vue&type=script&lang=ts&setup=true"

import "./AppNav.vue?vue&type=style&index=0&id=8b39fac0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b39fac0"]])

export default __exports__